import AddToBasket from './addToBasket'

export default AddToBasket
